import { email, phone } from '@/components/site-layout';
import { LegalPageLayout } from './legal-layout';

export default function PrivacyPage() {
  return (
    <LegalPageLayout
      title="Confidentialité"
      description="Données utilisées pour répondre aux demandes de devis SHER CLEAN, conservation, destinataires et droits des personnes."
    >
      <section>
        <h2>1. Responsable du traitement</h2>
        <p>
          Le responsable du traitement est Semra Handan ER, entrepreneur
          individuel, exploitant SHER SOLUTIONS — enseigne SHER CLEAN, 6 rue du
          Commandant Pierre Mulsant, 10000 Troyes. SIREN : 952 088 607. SIRET :
          952 088 607 00025. Pour toute question relative à vos données, écrivez
          à <a href={`mailto:${email}`}>{email}</a> ou appelez le{' '}
          <a href="tel:+33628730551">{phone}</a>.
        </p>
      </section>

      <section>
        <h2>2. Données traitées</h2>
        <p>
          Les informations demandées dépendent des prestations sélectionnées.
          Le formulaire recueille les coordonnées nécessaires pour vous répondre
          ainsi que les précisions utiles à l’étude du devis :
        </p>
        <ul>
          <li>
            <strong>Coordonnées :</strong> prénom, nom, adresse email,
            téléphone, ville et adresse principale de l’intervention. Si la
            collecte et le retour du linge ont lieu à deux adresses différentes,
            une adresse de retour est également demandée.
          </li>
          <li>
            <strong>Détails des prestations :</strong> selon votre sélection,
            type de logement, surface et nombre de pièces, nombre de fenêtres,
            volume et types de linge, équipement disponible, tâches de vigilance,
            appareils et besoin informatique, système d’exploitation si connu,
            type d’aide administrative, volume approximatif et précisions libres.
          </li>
          <li>
            <strong>Organisation souhaitée :</strong> fréquence, date de début
            souhaitée et disponibilités ; pour la vigilance, nombre ou fréquence
            des passages ; pour l’assistance informatique ou administrative,
            intervention ponctuelle ou régulière et échéance éventuelle.
          </li>
          <li>
            Les estimations peuvent être indiquées comme « Je ne sais pas / À
            préciser ». La ville est préremplie avec « Troyes », peut être
            modifiée et reste nécessaire pour envoyer la demande.
          </li>
          <li>
            Le formulaire ne demande ni mot de passe, ni code d’accès, ni
            document sensible ou numéro d’identité. Les dates exactes d’absence
            pour la vigilance sont convenues directement avec SHER CLEAN et ne
            doivent pas être indiquées ici.
          </li>
          <li>
            Un identifiant technique de demande et sa date de réception sont
            enregistrés pour assurer le suivi et éviter les doublons.
          </li>
        </ul>
      </section>

      <section>
        <h2>3. Finalités et bases légales</h2>
        <ul>
          <li>
            Préparer un devis, répondre à votre demande et échanger avec vous à
            ce sujet : mesures précontractuelles prises à votre demande.
          </li>
          <li>
            Organiser et suivre une prestation si vous acceptez le devis :
            exécution du contrat.
          </li>
          <li>
            Établir et conserver les documents requis par la réglementation :
            respect des obligations légales applicables.
          </li>
          <li>
            Protéger le formulaire et diagnostiquer les incidents techniques :
            intérêt légitime à sécuriser et maintenir le service.
          </li>
        </ul>
        <p>
          Une demande de devis n’entraîne pas d’inscription à une liste de
          prospection commerciale.
        </p>
      </section>

      <section>
        <h2>4. Destinataires des données</h2>
        <p>
          Vos données sont accessibles aux personnes habilitées de SHER CLEAN
          pour traiter votre demande et assurer le suivi de la relation client.
        </p>
        <p>
          Dans la mesure nécessaire à ces finalités, elles peuvent également
          être traitées par nos prestataires chargés de l’hébergement du site,
          du stockage des demandes et des services de messagerie et d’envoi
          d’emails, pour notre compte.
        </p>
      </section>

      <section>
        <h2>5. Durée de conservation</h2>
        <p>
          Pour une demande de devis qui ne donne pas lieu à un contrat, les
          données sont conservées pendant trois ans après le dernier échange
          avec le prospect, puis supprimées manuellement de la base et des
          copies d’emails contenant la demande lorsqu’elles sont présentes dans
          la messagerie IONOS. Aucune purge automatique n’est activée.
        </p>
        <p>
          L’application ne calcule ni ne suit automatiquement la date du dernier
          échange. Le délai est vérifié manuellement à partir de l’historique de
          la relation et des emails avant toute suppression. Les contrats,
          factures et documents clients sont exclus de cette règle et conservés
          selon leurs propres durées légales.
        </p>
      </section>

      <section>
        <h2>6. Vos droits</h2>
        <p>
          Dans les conditions prévues par la réglementation, vous pouvez
          demander l’accès à vos données, leur rectification ou leur
          effacement, la limitation du traitement, vous opposer à certains
          traitements et demander la portabilité des données que vous avez
          fournies. Pour exercer vos droits, écrivez à{' '}
          <a href={`mailto:${email}`}>{email}</a>. Une vérification raisonnable
          de votre identité pourra être demandée.
        </p>
        <p>
          Vous pouvez également adresser une réclamation à la{' '}
          <a href="https://www.cnil.fr/fr/plaintes" target="_blank" rel="noreferrer">
            Commission nationale de l’informatique et des libertés (CNIL)
          </a>
          .
        </p>
      </section>

      <section>
        <h2>7. Cookies et polices d’écriture</h2>
        <p>
          Le site utilise un cookie technique nécessaire à son fonctionnement.
          Aucun outil de mesure d’audience, de publicité ou d’enregistrement de
          session n’est utilisé.
        </p>
        <p>
          Les polices d’écriture sont chargées depuis Google Fonts. Ce
          chargement transmet à Google des informations techniques de connexion,
          notamment votre adresse IP.
        </p>
      </section>
    </LegalPageLayout>
  );
}
